module.exports = __webpack_public_path__ + "img/1564752082.4ffd2502.jpg";